import { render, staticRenderFns } from "./OwnerSettings.vue?vue&type=template&id=04c7ffc2&scoped=true"
import script from "./OwnerSettings.vue?vue&type=script&lang=js"
export * from "./OwnerSettings.vue?vue&type=script&lang=js"
import style0 from "./OwnerSettings.vue?vue&type=style&index=0&id=04c7ffc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c7ffc2",
  null
  
)

export default component.exports